import React, {useEffect} from "react";
import { Box, Typography, Button, Container, Paper, Checkbox, FormControlLabel } from "@mui/material";
import DOMPurify from 'dompurify';
import {TermsCurrentRequest, getCurrentTerms, termsAccepted} from "../../services/terms";
import {useNavigate} from "react-router-dom";



const TermsAndConditionsMobile: React.FC = () => {
  const [accepted, setAccepted] = React.useState(false);
  const navigate = useNavigate();

  const [termscondition, setTermscondition] = React.useState<TermsCurrentRequest>()
  useEffect(()=>{
      const getTerms = async ()=>{
          const response = await getCurrentTerms()
          if (response) {
              setTermscondition(response as TermsCurrentRequest)

          }

      }
      getTerms()
  },[])
  const handleAcceptTerms = async () => {
    try {
        await termsAccepted(termscondition?.id || 0)
        navigate('/bienvenida')
    } catch (error) {
        console.error('Error al aceptar los términos:', error)
    }
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="h5" gutterBottom textAlign="center">
          Términos y Condiciones
        </Typography>
        <Box
          sx={{
            maxHeight: "50vh",
            overflowY: "auto",
            my: 2,
            px: 1,
            border: "1px solid #ccc",
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
          }}
        >
          <Typography variant="body2" paragraph>
              {termscondition? <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(termscondition.text)}}/> : ''}
          </Typography>
          {/* Puedes agregar más párrafos aquí */}
        </Box>

        <FormControlLabel
          control={<Checkbox checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />}
          label="He leído y acepto los términos y condiciones"
        />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={!accepted}
          onClick={handleAcceptTerms}
          sx={{ mt: 2, borderRadius: 2 }}
        >
          Aceptar
        </Button>
      </Paper>
    </Container>
  );
};

export default TermsAndConditionsMobile;
